import { NgModule } from '@angular/core';
import { AirportLookupModalComponentModule } from '../airport-lookup/airport-lookup/airport-lookup-modal-component/airport-lookup-modal-component.module';
import { AirportLookupDirective } from './airport-lookup.directive';
import { AirportLookupModalComponent } from './airport-lookup/airport-lookup-modal-component/airport-lookup-modal.component';

@NgModule({
  imports: [AirportLookupModalComponentModule],
  declarations: [AirportLookupDirective],
  exports: [AirportLookupDirective]
})
export class AirportLookupModule {}
